module.exports = __webpack_public_path__ + "ab544136222a6e9d4f2c492da6961061.jpg";